import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { IconWrapper } from "../../Components/StyledComponents/StyledComponents";
import environmentVariables from "../../config/environmentVariables";


const PoolIcon = `${environmentVariables?.cdnUrl}poolIcon.png`;
const Root = styled.div`
  margin-top: ${(p) => p.theme.spacing.xl};
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    margin-top: ${(p) => p.theme.spacing.none};
  }
`;

const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 100%;
    padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.sm}
      ${(p) => p.theme.spacing.none} ${(p) => p.theme.spacing.sm};
  }
`;
const Heading = styled.div`
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  color: #e3e3e3;
  font-size: 24px;
  font-weight: ${(p) => p.theme.font.weight.bolder};
  display: flex;
  align-items: center;
`;

const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${(p) => p.theme.spacing.md};
  margin: ${(p) => p.theme.spacing.md} 0;

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    grid-template-columns: 1fr;
    gap: ${(p) => p.theme.spacing.sm};
  }
`;


const Card = styled.div`
  background: linear-gradient(180deg, #262a2d, #1f2326);
  border-radius: ${(p) => p.theme.radius.lg};
  padding: ${(p) => p.theme.spacing.lg};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 160px;
  border: 1px solid #2f3438;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
    border-color: #3b4247;
  }

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    padding: ${(p) => p.theme.spacing.md};
    min-height: 140px;
  }
`;


const Title = styled.div`
  font-size: ${(p) => p.theme.font.size.lg};
  font-weight: ${(p) => p.theme.font.weight.bolder};
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  margin-bottom: ${(p) => p.theme.spacing.xs};
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.xl};
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    font-size: ${(p) => p.theme.font.size.lg};
    font-weight: ${(p) => p.theme.font.weight.bold};
  }
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    font-size: ${(p) => p.theme.font.size.md};
  }
`;
const Button = styled.button`
  align-self: flex-start;
  padding: ${(p) => p.theme.spacing.xs} ${(p) => p.theme.spacing.md};
  border-radius: 999px;
  font-size: ${(p) => p.theme.font.size.sm};
  font-weight: ${(p) => p.theme.font.weight.bold};
  border: none;
  background-color: ${(p) => p.theme.colors.white};
  color: #000;
  cursor: pointer;
  transition: all 0.25s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    font-size: ${(p) => p.theme.font.size.xs};
  }
`;
const ComingSoonTag = styled.span`
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 8px;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 12px;
  letter-spacing: 0.5px;

background: rgb(32 55 54);
    color: #87fdfd;
    border: 1px solid rgb(129 241 241);
  

  cursor: default;
  user-select: none;
`;


const Icon = styled.img`
  width: 26px;
  height: 26px;
  aspect-ratio: auto 1/1;
`;

const MetaPoolSection = () => {
  let navigate = useNavigate();
  return (
    <Root>
      <Container>
        <Heading>
          <IconWrapper>
            <Icon src={PoolIcon} />
          </IconWrapper>{" "}
          Meta Market
        </Heading>
        <CardWrapper>
          <Card>
            <Title>NFT Staking</Title>
            <Button
              onClick={() => {
                navigate("/pool");
              }}
            >
              Stake Now
            </Button>
          </Card>
          <Card>
            <Title>$MLD Staking</Title>
            <Button style={{cursor:"default"}} disabled={true}>Coming Soon</Button>
           
          </Card>
        </CardWrapper>
      </Container>
    </Root>
  );
};

export default MetaPoolSection;
